import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	data: {},
	isLoading: false,
	hasBeenLoaded: false,
	error: ''
};

export const siteConfigSlice = createSlice({
	name: 'siteConfig',
	initialState,
	reducers: {
		getSiteConfig: (state) => {
			state.isLoading = true;
		},
		getSiteConfigCompleted: (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.hasBeenLoaded = true;
			state.error = '';
		},
		getSiteConfigFailed: (state, action) => {
			state.isLoading = false;
			state.hasBeenLoaded = false;
			state.error = action.payload;
		}
	}
});

export const { getSiteConfig, getSiteConfigCompleted, getSiteConfigFailed } =
	siteConfigSlice.actions;

export default siteConfigSlice.reducer;
